<script setup lang="ts">
import formatPrice from '@/helpers/formatPrice'
import type { LineItem, Invoice, Currency } from '@/types'
import UiHero from '@/components/UiHero/UiHero.vue'
import UiMultiHero from '@/components/UiMultiHero/UiMultiHero.vue'
import { computed } from 'vue'

interface Props {
  items: LineItem[]
  totalPrice: Invoice['price']
  currency?: Currency | null
  showMonthlyPayment?: boolean
  monthlyPayment?: number | null
}

const props = defineProps<Props>()

const titles = computed<string[]>(() => {
  return props.items.map((item) => `${item.name}`)
})

const formattedPrice = computed<string>(() => {
  const currencyLabel = props.currency?.code === 'usd' ? 'USD' : 'руб'

  if (props.showMonthlyPayment && props.monthlyPayment) {
    return `от ${formatPrice(props.monthlyPayment, true, currencyLabel)} / мес`
  }

  return formatPrice(props.totalPrice, true, currencyLabel)
})
</script>

<template>
  <ui-hero v-if="items.length === 1" :title="items[0].name" :subtitle="formattedPrice" />
  <ui-multi-hero
    v-else-if="items.length > 1"
    :titles="titles"
    :subtitle="formattedPrice"
  />
</template>
